import UserServiceClient from "./Clients/UserServiceClient";

export function activateEnterpriseBots(code) {
  return UserServiceClient.subscribeDomain({
    verificationCode: code,
  });
}
